const Emitter = require('tiny-emitter');
const emitter = new Emitter();

export default class Bus {
    public emit(event: string, ...args: any[]) {
        emitter.emit(event, ...args);
    }

    public once(event: string, callback: (...args: any[]) => void) {
        emitter.once(event, callback);
    }

    public on(event: string, callback: (...args: any[]) => void) {
        emitter.on(event, callback);
    }

    public off(event: string, callback: (...args: any[]) => void) {
        emitter.off(event, callback);
    }
}
